<div class="company-integrations">
  <div class="company-integrations__heading">
    <h3 class="vox-heading-3" translate>company.tabs.integrations</h3>
  </div>
  <div class="company-integrations__table">
    <gdp-integrations-table [company]="company" (onUpdateIntegrations)="fetchIntegrations()" [authMethodsType]="authMethodsType" [integrations]="integrations" [loading]="loading" context="company"></gdp-integrations-table>
    <gdp-table-pagination *ngIf="integrations?.length !== 0" (onSelectPageSize)="selectPageSize($event)" (onChangeCurrentPage)="changeCurrentPage($event)"
      [totalPages]="pagination.totalPages" [pagination]="pagination" [selectedPageSize]="pageSize">
    </gdp-table-pagination>
</div>
